import { DataChannel } from './channel';

export const draftChannel = {
  saved: new DataChannel<number>(),
  deleted: new DataChannel<boolean>(),
};
